import { HttpParams, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { BaseErrorStatus } from '@app/api/enums/base-error-status.enum';
import { IApiResponseError } from '@app/api/interfaces/common/api-response-error.interface';

export interface IInterceptorConfig {
  toIgnoreAll?: boolean;
  toIgnore?: {
    statusCodes?: HttpStatusCode[];
    errors?: Partial<IApiResponseError<BaseErrorStatus>>[];
  }[];
  toIgnoreNavigationCancellation?: boolean;
  /**
   * Keeps the request alive when everything else in the global http queue gets dropped
   * (see `queue-requests.interceptor.ts`). Meant for auth requests,
   * which must survive the logout cleanup.
   */
  toIgnoreQueueCancellation?: boolean;
  /**
   * Drops every cancellable request (both queued and in-flight) before this one starts.
   * Meant for requests that need a clean slate, e.g. logout.
   */
  toCancelPendingRequests?: boolean;
}

export type IParams = Record<string, string | readonly string[]>;

export class HttpInterceptorParams extends HttpParams {
  constructor(
    public interceptorConfig: IInterceptorConfig,
    params?: IParams
  ) {
    super({ fromObject: params });
  }
}

export function getHttpInterceptorConfig(request: HttpRequest<unknown>): IInterceptorConfig | null {
  return request.params instanceof HttpInterceptorParams ? request.params.interceptorConfig : null;
}
